module.exports = __webpack_public_path__ + "343678a9.svg";